import {toAbsoluteUrl} from '../../helpers'
import {KTSVG} from '../../helpers/components/KTSVG'
import {HowItWorks} from '../../../app/pages/landing/components/HowItWorks'
import {StartFreeToday} from '../../../app/pages/landing/components/StartFreeToday'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {PublicWrapper} from '../../../app/modules/common/components/PublicWrapper'
import {JoinBrands} from '../../../app/pages/landing/components/JoinBrands'
import {Link} from 'react-router-dom'
import {ROUTES} from '../../constants'
// import {MarketplacePromotionBanner} from '../../../app/modules/promotions/MarketplacePromotionBanner'
// import {TemuReferralBanner} from '../../../app/modules/promotions/TemuReferralBanner'

type Props = {
  pageClass?: string
  integrationLogo?: string
  integrationLogoAlt?: string
  integrateImg?: string
  card1Copy?: string
  card2Copy?: string
  card3Copy?: string
  card4Copy?: string
  store?: string
}

export function IntegrationsPageLayout({
  pageClass,
  integrationLogo,
  integrationLogoAlt,
  integrateImg,
  card1Copy,
  card2Copy,
  card3Copy,
  card4Copy,
  store,
}: Props) {
  const intl = useIntl()

  return (
    <>
      <PublicWrapper>
        <div className={clsx('bg-white', pageClass)}>
          <section className='integrations-detail-header'>
            <div className='integrations-detail-header-container'>
              <Link to={ROUTES.INTEGRATIONS.BASE} className='integrations-detail-header-back'>
                <KTSVG path='/media/gori/arrows/arrow_left.svg' className='svg-icon-2' />
                <h1 className='integrations-detail-header-title'>
                  {intl.formatMessage({id: 'INTEGRATION'})}
                </h1>
              </Link>
            </div>
          </section>
          {/* {store !== 'ShipStation' && store !== 'Temu' && <MarketplacePromotionBanner />} */}
          {/* {store === 'Temu' && <TemuReferralBanner />} */}

          <section>
            <div className='hero container d-flex flex-column align-items-center bg-white'>
              <div className='logo-container'>
                {integrationLogo && (
                  <img src={toAbsoluteUrl(integrationLogo)} alt={integrationLogoAlt} />
                )}
              </div>
              <div className='subtext-container d-flex flex-column align-items-center'>
                <h2 className='text-primary h2 text-center px-6 break-words'>
                  {intl.formatMessage({id: 'STORE_HEADER'}, {store: store})}
                </h2>
                <p className='text-center px-6 mb-0'>{intl.formatMessage({id: 'STORE_SUBTEXT'})}</p>
              </div>

              <Link
                to={ROUTES.AUTH.REGISTRATION}
                className='desktop-only btn-color btn btn-outline btn-primary-deep hover-orange rounded-pill text-center d-block w-fit-content mx-auto mb-12px custom-button'
              >
                <img
                  className='me-3'
                  src={toAbsoluteUrl('/media/gori/landing/store.svg')}
                  alt='store-icon'
                />
                {intl.formatMessage({id: 'LANDING_BUTTON_START_FREE'})}
              </Link>
            </div>
          </section>

          <HowItWorks heading={store} />

          <section>
            <div className='what-we-offer container'>
              <h2 className='text-orange h2 text-left'>What We Offer</h2>

              <ul className='d-flex flex-column justify-content-center align-items-center w-100'>
                {[
                  {img: integrateImg, copy: card1Copy, alt: 'integrate graphic'},
                  {
                    img: '/media/gori/integrations/shop-rates.webp',
                    copy: card2Copy,
                    alt: 'shop rates graphic',
                  },
                  {
                    img: '/media/gori/integrations/at-a-glance.webp',
                    copy: card3Copy,
                    alt: 'at a glance graphic',
                  },
                  {
                    img: '/media/gori/integrations/tools.webp',
                    copy: card4Copy,
                    alt: 'tools graphic',
                  },
                ].map((item, index) => (
                  <li
                    key={index}
                    className='w-100 d-flex flex-column flex-md-row justify-content-center align-items-center'
                  >
                    {item.img && (
                      <img className='d-block' src={toAbsoluteUrl(item.img)} alt={item.alt} />
                    )}
                    <div>
                      <p>{intl.formatMessage({id: item.copy})}</p>
                    </div>
                  </li>
                ))}
              </ul>
              <Link
                to={ROUTES.PRODUCTS.PRODUCT}
                className='desktop-only btn-color btn btn-outline btn-primary-deep hover-orange rounded-pill text-center d-block w-fit-content mt-12 mx-auto mb-12px custom-button'
              >
                {intl.formatMessage({id: 'LANDING_BUTTON_LEARN_MORE'})}
              </Link>
            </div>
          </section>

          <JoinBrands />

          <StartFreeToday />
        </div>
      </PublicWrapper>
    </>
  )
}
